/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbAdmissionCoordinatorPage } from './HchbAdmissionCoordinatorPage';
import {
    HchbAdmissionCoordinatorPageFromJSON,
    HchbAdmissionCoordinatorPageFromJSONTyped,
    HchbAdmissionCoordinatorPageToJSON,
    HchbAdmissionCoordinatorPageToJSONTyped,
} from './HchbAdmissionCoordinatorPage';

/**
 * 
 * @export
 * @interface FindAllHchbAdmissionCoordinators200Response
 */
export interface FindAllHchbAdmissionCoordinators200Response {
    /**
     * 
     */
    data?: HchbAdmissionCoordinatorPage;
}

/**
 * Check if a given object implements the FindAllHchbAdmissionCoordinators200Response interface.
 */
export function instanceOfFindAllHchbAdmissionCoordinators200Response(value: object): value is FindAllHchbAdmissionCoordinators200Response {
    return true;
}

export function FindAllHchbAdmissionCoordinators200ResponseFromJSON(json: any): FindAllHchbAdmissionCoordinators200Response {
    return FindAllHchbAdmissionCoordinators200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbAdmissionCoordinators200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbAdmissionCoordinators200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbAdmissionCoordinatorPageFromJSON(json['data']),
    };
}

export function FindAllHchbAdmissionCoordinators200ResponseToJSON(json: any): FindAllHchbAdmissionCoordinators200Response {
    return FindAllHchbAdmissionCoordinators200ResponseToJSONTyped(json, false);
}

export function FindAllHchbAdmissionCoordinators200ResponseToJSONTyped(value?: FindAllHchbAdmissionCoordinators200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbAdmissionCoordinatorPageToJSON(value['data']),
    };
}

